export const isUserWithClientId = (
  clientsIds: { [key: string]: boolean } | undefined,
  clientId: string
): boolean => {
  return Boolean(clientsIds && clientsIds[clientId]);
};
